__turbopack_context__.v({
  "sponsorship_franchise_row": "SponsorshipFranchiseRow-module-scss-module__W41Lla__sponsorship_franchise_row",
});
